
import en from'@24i/prd-localization-files-prj1370bro/dist/en.json';

export var i18nOptions={
resources:{
en:{sott:en}
}
};